module.exports = __webpack_public_path__ + "static/media/amelia_mistreanu.10ca7d83.png";